<template>
  <div>
    <b-card class="mt-1 mb-1">
      <b-media vertical-align="center">
        <span
          class="font-weight-bold d-block"
        >
          {{ user.name }}
        </span>
        <div style="margin-top: 4px">
          <b-badge
            pill
            variant="light-warning"
          >
            {{ user.point }} poin
          </b-badge> <small class="text-muted">bergabung sejak {{ formatDate(user.created_at) }}</small>
        </div>
      </b-media>
    </b-card>
    <div class="p-1">
      <table class="mt-xl-0 w-100">
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="MailIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Email</span>
          </th>
          <td class="pb-50">
            <a
              v-if="user.email"
              target="_blank"
              :href="`mailto:${user.email}`"
            >{{ user.email }}</a>
            <span v-else>-</span>
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="PhoneIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Nomor Telepon</span>
          </th>
          <td class="pb-50 text-capitalize">
            <a
              v-if="user.phone"
              target="_blank"
              :href="`https://wa.me/${user.phone}`"
            >+{{ user.phone }}</a>
            <span v-else>-</span>
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="CreditCardIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Mini Wallet</span>
          </th>
          <td class="pb-50">
            {{ toCurrency(user.mini_wallet_balance || 0) }}
          </td>
        </tr>
        <tr>
          <th class="pb-50">
            <feather-icon
              icon="StarIcon"
              class="mr-75"
            />
            <span class="font-weight-bold">Kode Referral</span>
          </th>
          <td class="pb-50 text-capitalize">
            <a
              v-b-tooltip.hover.top="'Salin Kode'"
              href="#"
              @click.prevent="copy(user.referral_code)"
            >
              {{ user.referral_code }}
            </a>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BBadge,
  VBTooltip,
  BMedia,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BBadge,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BMedia,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    async copy(mytext) {
      try {
        await navigator.clipboard.writeText(mytext)
        this.$toast({
          component: ToastificationContent,
          props: {
            icon: 'CheckIcon',
            text: 'Kode referral berhasil disalin.',
            variant: 'success',
          },
        })
      } catch ($e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            icon: 'AlertTriangleIcon',
            text: 'Kode referral gagal disalin.',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>
